import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import PortfolioSection from './components/PortfolioSection';
import PricingSection from './components/PricingSection';
import QuoteFormSection from './components/QuoteFormSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import FooterSection from './components/FooterSection.jsx';

const PremiumBalconyGlazingServiceLandingPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <PortfolioSection />
        <PricingSection />
        <TestimonialsSection />
        <QuoteFormSection />
        <FAQSection />
      </main>
      <FooterSection />
    </div>
  );
};

export default PremiumBalconyGlazingServiceLandingPage;